module.exports = __webpack_public_path__ + "static/media/logo.1ced9528.png";